import createRouter from 'router5';
import loggerPlugin from 'router5-plugin-logger';
import browserPlugin from 'router5-plugin-browser';
import routes from './routes';

/**
 * Configure app router
 * @return {Router<DefaultDependencies>}
 */
export default function configureRouter() {
  const router = createRouter(routes, {
    defaultRoute: '/',
    allowNotFound: true,
    queryParamsMode: 'loose',
  });

  router.usePlugin(loggerPlugin);
  router.usePlugin(browserPlugin());

  return router.start();
}
